/* global messg */
import I18n from 'lib/i18n'
import PropTypes from 'prop-types'

import createListenerForm from 'lib/kea/create-listener-form'
import RawField from 'lib/kea/field'
import isEmailValid from 'lib/utils/is-email-valid'

import controller from './controller.rb'

const isExist = (email, list) => list.filter(e => e === email).length > 0

const form = createListenerForm({
  path: () => ['scenes', 'pagesInvite', 'form'],

  defaults: {
    emailList: ['', '', '']
  },

  actions: logic => ({
    updateExistingMails: emails => ({ emails }),
    updateAlreadyInvitedMails: emails => ({ emails })
  }),

  reducers: ({ actions }) => ({
    existingMails: [
      [],
      PropTypes.array,
      {
        [actions.updateExistingMails]: (_, payload) => payload.emails
      }
    ],
    alreadyInvitedMails: [
      [],
      PropTypes.array,
      {
        [actions.updateAlreadyInvitedMails]: (_, payload) => payload.emails
      }
    ]
  }),

  selectors: ({ selectors }) => ({
    validationErrors: [
      () => [selectors.formValues, selectors.existingMails, selectors.alreadyInvitedMails],
      ({ emailList }, existingMails, alreadyInvitedMails) => {
        let hasErrors = false

        const newEmailList = emailList.map(email => {
          if (email && !isEmailValid(email)) {
            hasErrors = true
            return I18n.t('courses.show_share.email_error_not_email')
          }
          if (email && isExist(email, existingMails)) {
            hasErrors = true
            return I18n.t('courses.show_share.email_exist_message')
          }
          if (email && isExist(email, alreadyInvitedMails)) {
            hasErrors = true
            return I18n.t('courses.show_share.already_invited_message')
          }
          return false
        })

        return {
          emailList: hasErrors ? newEmailList : null
        }
      }
    ]
  }),

  listeners: ({ actions, values }) => ({
    [actions.submitRequest]: async function () {
      try {
        const { formValues } = values
        const invites = formValues.emailList.filter(email => !!email)

        if (invites.length <= 30) {
          const response = await controller.sendInvites({ invites })
          if (response.success) {
            actions.submitSuccess(response, formValues)
            actions.showErrors()
            response.message && messg.success(response.message, 4000)

            const { existingMails, alreadyInvitedMails } = response

            actions.updateExistingMails(existingMails || [])
            actions.updateAlreadyInvitedMails(alreadyInvitedMails || [])

            let emailList = [...(existingMails || []), ...(alreadyInvitedMails || [])]
            if (emailList.length < 3) {
              emailList = ['', '', ''].map((a, i) => emailList[i] || a)
            }

            actions.setValue('emailList', emailList)
          } else {
            messg.error(response.error, 2500)
            throw new Error('Not successful')
          }
        } else {
          actions.submitFailure()
        }
      } catch (error) {
        actions.submitFailure(error)
      }
    }
  })
})

export default form
export const Field = form.getField()
